import '../internationalization/i18n';
import '@oliasoft-open-source/react-ui-library/dist/global.css';
import { HistoryRouter } from 'redux-first-history/rr6';
import { Provider } from 'react-redux';
import { PkceProvider, PkceSecure } from '@oliasoft/pkce';
import { store, history } from 'client/store/configureStore';
import { ErrorBoundary, Toaster } from '@oliasoft-open-source/react-ui-library';
import { MathJaxContext } from 'better-react-mathjax';
import { AppContent } from 'client/components/app-content/AppContent';
import { SocketProvider } from '../store/notification-service/socket-context';
import ClientConfig from '../config';
import './theme.css';
import { UnitTemplateContextProvider } from './hoc/with-unit-template';

const App = () => {
  return (
    <Provider store={store}>
      <PkceProvider
        provider={ClientConfig.config.pkce.provider}
        renewTokenMode={ClientConfig.config.pkce.renewTokenMode}
        clientId={ClientConfig.config.applicationId}
        idpServerUrl={ClientConfig.config.idpServerUrl}
        hostBaseUrl={ClientConfig.config.hostBaseUrl}
        scope="openid profile atlas-api"
        history={history}
      >
        <HistoryRouter history={history}>
          <ErrorBoundary>
            <PkceSecure>
              <SocketProvider>
                <MathJaxContext config={{ loader: { load: ['input/asciimath'] } }}>
                  <UnitTemplateContextProvider>
                    <AppContent />
                  </UnitTemplateContextProvider>
                  </MathJaxContext>
                </SocketProvider>
              </PkceSecure>
             </ErrorBoundary>
          <Toaster />
        </HistoryRouter>
      </PkceProvider>
    </Provider>
  );
};

export default App;
